(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2596],{

/***/ 32596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M75MediaText": function() { return /* reexport */ M75MediaText; },
  "default": function() { return /* reexport */ M75MediaText; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(21175);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/link.js
var next_link = __webpack_require__(92072);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ./src/constants/index.ts + 1 modules
var constants = __webpack_require__(92658);
// EXTERNAL MODULE: ./src/components/modules/M75MediaText/M75MediaText.module.css
var M75MediaText_module = __webpack_require__(70297);
var M75MediaText_module_default = /*#__PURE__*/__webpack_require__.n(M75MediaText_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/components/modules/M75MediaText/M75MediaText.tsx


const _excluded = ["image", "video", "headline", "subHeadline", "text", "callToAction", "mediaHorizontalAlignment"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const M75MediaText = _ref => {
  let {
    image,
    video,
    headline,
    subHeadline,
    text,
    callToAction,
    mediaHorizontalAlignment = 'left'
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const shouldDisplayImage = video && video.length > 0 ? false : true;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleContainer */.EM, _objectSpread(_objectSpread({}, rest), {}, {
    hasPadding: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((M75MediaText_module_default()).m75),
        style: {
          maxWidth: constants/* sizes.contentMaxWidth */.J.contentMaxWidth
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,clsx_m/* default */.Z)((M75MediaText_module_default()).m75Content, (M75MediaText_module_default())[`media-align-${mediaHorizontalAlignment}`], {
            [(M75MediaText_module_default()).mediaAlignLeft]: mediaHorizontalAlignment === 'left',
            [(M75MediaText_module_default()).mediaAlignRight]: mediaHorizontalAlignment === 'right'
          }),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* AlignContent */.tk, {
            alignment: "left",
            position: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [subHeadline ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "bodyExtraSmall",
                children: subHeadline
              }) : null, headline ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "display3",
                children: headline
              }) : null]
            }), text ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* RawHtml */.j1, {
              html: text
            }) : null, callToAction && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
              href: callToAction.url,
              passHref: true,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                variant: "link",
                iconPosition: "right",
                iconName: "arrow-right",
                target: callToAction === null || callToAction === void 0 ? void 0 : callToAction.target,
                title: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title,
                className: (M75MediaText_module_default()).linkOverride,
                draggable: false,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                  children: callToAction === null || callToAction === void 0 ? void 0 : callToAction.title
                })
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,clsx_m/* default */.Z)((M75MediaText_module_default()).gridAreaMedia),
            children: [shouldDisplayImage && image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, _objectSpread(_objectSpread({}, image), {}, {
              layout: "responsive",
              sizes: `(max-width: ${constants/* breakpoints.xs */.A.xs}px) 100vw, ${constants/* sizes.contentMaxWidth */.J.contentMaxWidth} 50vw, 720px`
            })) : null, !shouldDisplayImage && video ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Video */.nk, {
              controls: true,
              src: video,
              posterSrc: image === null || image === void 0 ? void 0 : image.src
            }) : null]
          })]
        })
      })
    })
  }));
};
;// CONCATENATED MODULE: ./src/components/modules/M75MediaText/index.ts



/***/ }),

/***/ 92658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ breakpoints; },
  "J": function() { return /* reexport */ sizes; }
});

;// CONCATENATED MODULE: ./src/constants/constants.ts
const breakpoints = {
  /**
   * Mobile devices. Use orientation media queries for landscape styling
   */
  xs: 767,

  /**
   * Small tablets
   */
  sm: 768,

  /**
   * Large tablets, small laptops
   */
  md: 1024,

  /**
   * Desktops, laptops
   */
  lg: 1367,

  /**
   * Wide screens
   */
  xl: 1730
};
const sizes = {
  // Limit content
  contentMaxWidth: 1690,
  headerHeightDesktop: 70,
  // Limit page width. Background colors etc.
  pageMaxWidth: 1690,
  // Header checkout
  headerHeightCheckout: 93,
  checkoutMinHeaderHeight: 130,
  content: 'min(88vw, 1690px)',
  // Default Width for side Drawer
  drawerWidth: 480,
  mobileDrawerWidth: 300,
  // Search bar height
  searchHeight: 46
};
const aspectRatios = {
  imageProduct: '2475 / 3262',
  imageModel: '2 / 3'
};
;// CONCATENATED MODULE: ./src/constants/index.ts


/***/ }),

/***/ 70297:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m75":"M75MediaText_m75__prjt5","m75Content":"M75MediaText_m75Content__0Cl7F","dark":"M75MediaText_dark__yUcB4","mediaAlignRight":"M75MediaText_mediaAlignRight__6p8SI","mediaAlignLeft":"M75MediaText_mediaAlignLeft__HjbWU","gridAreaMedia":"M75MediaText_gridAreaMedia__TY3r4","linkOverride":"M75MediaText_linkOverride__XmMf8"};

/***/ })

}]);